import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../assets/scss/pages.module.scss";
import ArtistAccount from "sections/registrationPage/artistAccount/ArtistAccount";
import ArtistRepresentativeAccount from "sections/registrationPage/artistRepresentativeAccount/ArtistRepresentativeAccount";

const RegistrationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const accountType = location?.state?.accountType;

  useEffect(() => {
    if (!accountType) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!accountType) {
    return null;
  }

  return (
    <div className={styles.registrationPageContainer}>
      <div className="container">
        {accountType === "artist" ? <ArtistAccount /> : null}
        {accountType === "artist-representative" ? (
          <ArtistRepresentativeAccount />
        ) : null}
      </div>
    </div>
  );
};

export default RegistrationPage;
